
<nb-tabset (changeTab)="onChangeTab($event)">
  <nb-tab *ngIf="usersRol.CONSULTAR_BUQUES" tabTitle="Consulta" tabIcon="search-outline" responsive style="height: 80vh;">
    <p class="Titulo">Consulta - Buques</p>
      <button nbButton shape="round" size="small" class="buttontz float-left" style="margin-bottom: 10px;" (click)="consultarBuquesConsulta()">
        <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
      </button>
      <app-spinner *ngIf="showSpinnerConsulta"></app-spinner>
      <div>
        <div *ngIf="showBuquesConsulta">
          <!-- <angular-slickgrid gridId="gridBuquesConsulta"
              [columnDefinitions]="columnDefinitionsBuquesConsulta"
              [gridOptions]="gridOptionsBuquesConsulta" 
              [dataset]="datasetBuquesConsulta" 
              gridHeight="380"
              gridWidth="75%"
              (onAngularGridCreated)="angularGridReadyBuquesConsulta($event)">
            </angular-slickgrid> -->
            <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 75%; height: 380px;"
            [rowData]="datasetBuquesConsulta"
            [columnDefs]="columnDefinitionsBuquesConsulta"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
        </div>
      </div>
        <button nbButton size="tiny" style="float: right; margin-top: 50px;" class=" buttontz" [hidden]="!showBuquesConsulta" [disabled]="!showBuquesConsulta"
        (click)="exportToExcelBuques()" ><nb-icon icon="save-outline"></nb-icon>Exportar</button>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_BUQUES" tabTitle="Alta" tabIcon="upload-outline" responsive style="height: 80vh;">
  <div class="row">
    <div class="col-4 float-left">
      <p class="Titulo">Alta Buques</p>
      <p-dropdown required class="limited-selector" id="inputOperadorNaviera" placeholder="Seleccionar Operador"
      [style]="{'width':'75%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="operadorNaviera"
      [(ngModel)]="operadorProcesado" (onChange)="obtenerDescripcionDropdown(operadorProcesado)"
      [virtualScroll]="true"
      [itemSize]="31" 
      [filter]="true"
      [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
      >
    </p-dropdown>

      <p>
        <mat-form-field class="altaLabel">
          <mat-label>Ingresar Descripción</mat-label>
          <input matInput #message1 maxlength="80" [(ngModel)]="descripcionBuques" name="descripcion">
          <mat-hint align="end">{{message1.value.length}} / 80</mat-hint>
        </mat-form-field>
      </p>

      <p>
        <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
        <button *ngIf="!showSpinnerGuardar" nbButton size="tiny" status="primary" class="buttontz" (click)="altaBuques()">Guardar</button>
      </p>
    </div>
    <div>
      <button nbButton shape="round" size="small" class="buttontz float-right" (click)="consultarBuques()">
        <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
      </button>
    </div>
    <app-spinner class="float-right col-6" *ngIf="showSpinner"></app-spinner>
    <div *ngIf="showBuques" class="float-right col-6">
      <!-- <angular-slickgrid gridId="gridBuques"
          [columnDefinitions]="columnDefinitionsBuques"
          [gridOptions]="gridOptionsBuques" 
          [dataset]="datasetBuques" 
          gridHeight="380"
          (onAngularGridCreated)="angularGridReadyBuques($event)">
        </angular-slickgrid> -->
      <ag-grid-angular
            #grilla2
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetBuques"
            [columnDefs]="columnDefinitionsBuques"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
  </div>
</div>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_BUQUES" tabTitle="Modificación" tabIcon="edit-outline" responsive style="height: 75vh;">
    <p class="Titulo">Modificar Buques</p>
    <div class="row">
      <div class="col-4 float-left">
      <p-dropdown required class="limited-selector" id="inputBuques" placeholder="Seleccionar Buques"
        [style]="{'width':'75%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="buques"
        [(ngModel)]="BuquesProcesadoModificar" (onChange)="obtenerDescripcionDropdown(BuquesProcesadoModificar)" [virtualScroll]="true"
        [itemSize]="31" [filter]="true"
        [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
  
        >
      </p-dropdown>
      <p>
        <mat-form-field class="altaLabelModificacion">
          <mat-label>Descripcion</mat-label>
          <input matInput #message4 maxlength="80" [(ngModel)]="descripcionBuquesEditar" name="descripcionBuquesEditar">
          <mat-hint align="end">{{message4.value.length}} / 80</mat-hint>
        </mat-form-field>
      </p>
      <p-dropdown required class="limited-selector" id="inputOperadorNavieraModificar" placeholder="Seleccionar Operador"
      [style]="{'width':'75%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="operadorNaviera"
      [(ngModel)]="operadorProcesadoModificar" 
      [virtualScroll]="true"
      [itemSize]="31" [filter]="true"
      [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}"
      >
    </p-dropdown>
      <div>
        <p>
          <nb-checkbox (checkedChange)="toggleEliminar($event)" [(ngModel)]="eliminarSeleccionado">Eliminar</nb-checkbox>
        </p>
        <p>
          <app-spinner *ngIf="showSpinnerModificar"></app-spinner>
          <button *ngIf="!showSpinnerModificar" nbButton size="tiny" status="primary" class="buttontz" (click)="modificarBuques()">Modificar</button>
        </p>
      </div>
      </div>
        <app-spinner class="float-right col-6" *ngIf="showSpinnerModificar"></app-spinner>
      <div *ngIf="showBuquesModificar" class="col-6 float-right" [hidden]="showSpinnerModificar">
          <!-- <angular-slickgrid gridId="gridBuques"
              [columnDefinitions]="columnDefinitionsBuquesModificar"
              [gridOptions]="gridOptionsBuquesModificar" 
              [dataset]="datasetBuquesModificar" 
              gridHeight="380"
              (onAngularGridCreated)="angularGridReadyBuquesModificar($event)">
          </angular-slickgrid> -->

          <ag-grid-angular
            #grilla3
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetBuquesModificar"
            [columnDefs]="columnDefinitionsBuquesModificar"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
        </div>
    </div>
  </nb-tab>
</nb-tabset>
